import { Form } from "antd"
import React from "react"

import { PhoneInput } from "../../../../../components/PhoneInputs/PhoneInput.tsx"
import { placeholders } from "../../../../../constants/placeholders"
import { validatePhone } from "../../../../../utils/validation/validate-phone.ts"
import { type TeamMembersFilterOptions } from "../../../../TeamManagementPage/redux/team-members.types.ts"
import { type SettingsCompanyFormData } from "../SettingsCompanyForm.tsx"
import { CompanyInformationFormAddress } from "./CompanyInformationFormAddress.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface CompanyInformationFormSectionProps {
  options: TeamMembersFilterOptions | null
  isBranchScope?: boolean
}

export function CompanyInformationFormSection({
  options,
  isBranchScope
}: CompanyInformationFormSectionProps) {
  return (
    <>
      <div
        data-guide-target="company-details-section"
        className="grid grid-cols-1 gap-x-3 sm:grid-cols-2"
      >
        <Form.Item<SettingsCompanyFormData>
          label={isBranchScope ? "Branch Name" : "Company Name"}
          name="business_name"
          rules={[
            {
              required: true,
              message: isBranchScope
                ? "Please enter the branch name"
                : "Please enter your company name"
            }
          ]}
        >
          <TextInput
            placeholder={isBranchScope ? "Enter branch name" : "Enter company name"}
          />
        </Form.Item>

        <Form.Item<SettingsCompanyFormData>
          label={"Phone"}
          name="company_phone"
          rules={[{ required: true, validator: validatePhone }]}
        >
          <PhoneInput placeholder={placeholders.phone} />
        </Form.Item>
      </div>

      <CompanyInformationFormAddress options={options} />

      <Form.Item<SettingsCompanyFormData>
        label={"Website"}
        name="company_website"
        rules={[
          {
            type: "url",
            message: "Please enter a valid URL"
          }
        ]}
      >
        <TextInput disableAutoCapitalize placeholder={"Enter website"} />
      </Form.Item>
    </>
  )
}
